export const sunIcon = {
  name: 'sun',
  viewBox: '0 0 16 16',
  content: `
    <line x1="8" y1="1" x2="8" y2="3"
          stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
    <line x1="8" y1="13" x2="8" y2="15"
          stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
    <line x1="1" y1="8" x2="3" y2="8"
          stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
    <line x1="13" y1="8" x2="15" y2="8"
          stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
    <line x1="3.05" y1="3.05" x2="4.46" y2="4.46"
          stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
    <line x1="11.54" y1="11.54" x2="12.95" y2="12.95"
          stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
    <line x1="12.95" y1="3.05" x2="11.54" y2="4.46"
          stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
    <line x1="4.46" y1="11.54" x2="3.05" y2="12.95"
          stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
    <circle cx="8" cy="8" r="2.5"
            fill="none" stroke="currentColor" stroke-width="1"/>
  `,
};

export const moonIcon = {
  name: 'moon',
  viewBox: '0 0 16 16',
  content: `
    <path d="M13,8 A5,5 0 1,1 8,3 A3.5,3.5 0 1,0 13,8 Z"
          fill="none" stroke="currentColor" stroke-width="1"
          stroke-linejoin="round"/>
  `,
};
